import styled from 'styled-components';

import type {Props} from './types';

import LogoIcon from '../../assets/icons-colored/logo.svg';
import LogoTextIcon from '../../assets/icons/logo-text.svg';
import PwrIcon from '../../assets/icons/PWR.svg';
import {ms, msi} from '../../styles/normalizeSize';
import {getColor, getFontWeight} from '../../styles/utils';
import {platform} from '../../utils/platform';
import {Text} from '../Text';
import {View} from '../View';

export const Container = styled(View)`
  position: relative;
  display: ${platform.isNative ? 'flex' : 'inline-flex'};
  flex-direction: row;
  align-items: center;
`;

const SLogoIcon = styled(LogoIcon)`
  margin-right: ${ms(10)};
`;

const SLogoTextIcon = styled(LogoTextIcon).attrs<{color?: Props['textColor']}>(
  p => ({
    fill: getColor(p.color || 'text6')(p),
    preserveAspectRatio: platform.isNative ? 'xMidyMid slice' : undefined,
  }),
)<{color?: Props['textColor']}>``;

const SPwrIcon = styled(PwrIcon).attrs(p => ({
  fill: getColor('icon2')(p),
}))``;

export {
  SLogoIcon as LogoIcon,
  SLogoTextIcon as LogoTextIcon,
  SPwrIcon as PwrIcon,
};

export const PwrContainer = styled(View)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: ${ms(-3)};
  padding: ${ms(3)} ${ms(2)} ${ms(3)} ${ms(4)};
  background-color: ${getColor('global1')};
  border-radius: ${ms(3)};
`;

export const Label = styled(Text)`
  position: absolute;
  right: 0;
  bottom: ${ms(1)};
  color: ${getColor('text6')};
  font-weight: ${getFontWeight('bold')};
  font-size: ${ms(12)};
  line-height: ${ms(14)};
  letter-spacing: ${ms(-0.2)};
`;

const RATIO = 15 / 40;
const TEXT_WIDTH_RATIO = 529 / 59;
const PWR_HEIGHT_RATIO = 7 / 40;
const PWR_WIDTH_RATIO = 26 / 9;

export const getCalculatedStyles = (size: Props['size']) => {
  size = msi(size || 50);

  const textHeight = size * RATIO;
  const pwrHeight = size * PWR_HEIGHT_RATIO;
  const labelHeight = size * 0.25;

  const logo = {
    height: size,
    width: size,
  };

  const text = {
    height: textHeight,
    width: textHeight * TEXT_WIDTH_RATIO,
  };

  const pwr = {
    height: pwrHeight,
    width: pwrHeight * PWR_WIDTH_RATIO,
  };

  const label = {
    fontSize: labelHeight * 0.8,
    // add unit for web env
    lineHeight: platform.isNative ? labelHeight : `${labelHeight}px`,
  };

  return {
    label,
    logo,
    pwr,
    text,
  };
};
